<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.course.courseList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.course.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.course.courseTitle')}}</label>
                                        <input type="text" v-model="search.title" @keyup="searchCourse"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.course.courseCode')}}</label>
                                        <input type="text" v-model="search.Code" @keyup="searchCourse"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.course.SBSCredits')}}</label>
                                        <input type="text" v-model="search.sbsCredits" @keyup="searchCourse"
                                            class="search form-control">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.course.ECTSCredits')}}</label>
                                        <input type="text" v-model="search.ectsCredits" @keyup="searchCourse"
                                            class="search form-control">
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.course.presetName')">
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <button type="button" class="btn btn-primary"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button type="button" class="btn btn-danger" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.course.courseList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="course_list.length">
                            <thead>
                                <tr class="header">
                                    <th>{{$t('form.course.courseID')}}</th>
                                    <th>{{$t('form.course.courseTitle')}}</th>
                                    <th>{{$t('form.course.courseCode')}}</th>
                                    <th>{{$t('form.course.SBSCredits')}}</th>
                                    <th>{{$t('form.course.ECTSCredits')}}</th>
                                    <th class="text-right">{{$t('form.course.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(course, index) in course_list" :key="index">
                                <tr @dblclick="editCourse(index)">
                                    <td>
                                        {{course.ID}}
                                    </td>
                                    <td>
                                        {{course.CourseTitle}}
                                    </td>
                                    <td>
                                        {{course.CourseCode}}
                                    </td>
                                    <td>
                                        {{course.SBSCredits}}
                                    </td>
                                    <td>
                                        {{course.ECTSCredits}}
                                    </td>
                                    <td class="text-right">
                                        <button class="btn btn-info btn btn-sm personal_btn_info"
                                            v-on:click="editCourse(index , true)" v-show="permissions.viewCourses">
                                            <span class="fa fa-copy"></span>
                                        </button>
                                        <button v-show="permissions.viewCourses" class="btn btn-info btn-sm"
                                            @click="editCourse(index)">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn btn-danger btn-sm" @click="deleteCourse(index)"
                                            v-show="permissions.deleteCourses">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                requestSource: '',
                detailedSearch: false,
                presetSelected: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: '',
                    entity: 'course',
                    value: {}
                },

                course_list: [],
                presetList: [],
            }
        },

        mounted() {
            this.isLoading = true;
            
            if (!this.permissions.viewCourses) {
                this.$router.push('/');
                return;
            }

            if (localStorage.getItem('filter-course')) {
                this.search = JSON.parse(localStorage.getItem('filter-course'));
            }

            this.getCourses();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-course', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            getCourses() {
                let source = axios.CancelToken.source();

                if (this.requestSource != '')
                    this.requestSource.cancel('Operation canceled by the user.');

                this.requestSource = source;

                this.isLoading = true;
                axios
                    .get('/api/courses?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.requestSource.token
                    })
                    .then(response => {
                        this.course_list = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },

            clearSearch() {
                this.search = {};
                this.searchCourse();
            },

            searchCourse() {
                this.pagination.current_page = 1;
                this.getCourses();
            },

            paginate() {
                this.getCourses();
            },

            editCourse(index , clone = false) {
                if (!this.permissions.viewCourses) return;

                var id = this.course_list[index].ID;

                this.$router.push({
                    name: clone ? "CourseClone":"CourseEdit",
                    params: {
                        id: id,
                        clone: clone,
                    }
                });
            },

            deleteCourse(index) {
                if (!this.permissions.deleteCourses) return;

                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/courses/" + this.course_list[index].ID)
                        .then(response => {

                            if (response.data.warning_professor) {
                                this.showAlert(response.data.message, 'danger');
                            } else if (response.data.warning_student) {
                                this.showAlert(response.data.message, 'danger');
                            } else if (response.data.warning_program) {
                                this.showAlert(response.data.message, 'danger');
                            } else if (response.data.warning_book) {
                                this.showAlert(response.data.message, 'danger');
                            } else {
                                this.search_code = null;
                                this.search_title = null;
                                this.course_list.splice(index, 1);
                                this.getCourses();
                                this.showAlert(response.data.message);
                            }
                        })
                        .catch(error => {});
                }
            },

            /**
             * Preset CRUD
             */
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            loadPreset() {
                if (!this.preset) {
                    this.search = {};
                    this.preset = {
                        entity: 'course'
                    };
                    this.searchCourse();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchCourse();
            },

            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.search = {};
                                this.searchCourse();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }

        }
    }

</script>
